import { errorHandler } from "./errorHandler";
import { CreateWebsiteData } from "../interface";
import { apiRequest } from "./apiRequest";

export const postWebsite = async (args: CreateWebsiteData): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>("post", `/websites`, {
      data: args,
    });

    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to create user");
  }
};
